export default __webpack_public_path__ + "static/media/icon.water filters.cc426a12.svg";